import React from 'react';
import { Eye, LogOut } from 'lucide-react';

import { useAuth } from '../context/AuthContext';

function ImpersonationBanner() {
  const { user, stopImpersonation } = useAuth();

  if (!user?.isImpersonating) { return null; }

  return (
    <div className="bg-amber-500 text-white px-4 py-2 text-sm">
      <div className="flex items-center justify-between gap-4 max-w-full">
        <div className="flex items-center gap-2 min-w-0">
          <Eye size={16} className="shrink-0" />
          <span className="font-medium truncate">
            Support mode: you are viewing as {user.email} ({user.role})
          </span>
        </div>
        <button
          onClick={stopImpersonation}
          className="inline-flex items-center gap-1.5 shrink-0 px-2.5 py-1 rounded-md bg-white/15 hover:bg-white/25 transition-colors text-xs font-semibold"
        >
          <LogOut size={12} /> End session
        </button>
      </div>
    </div>
  );
}

export default ImpersonationBanner;
